import { FC, useMemo } from "react";
import Stack from "@mui/material/Stack";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";
import { CostType } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerViewBudgetsSelector } from "@/store/resource-explorer/selectors/budget/resourceExplorerViewBudgetsSelector";

export const ResourceExplorerBudgetSelectTriggerComponent: FC<
  FilterTriggerComponentProps
> = ({ selectedValues, open, onClick }) => {
  const budgets = useAppSelector(resourceExplorerViewBudgetsSelector);

  const value = selectedValues[0] as CostType;

  const budgetName = useMemo(() => {
    return budgets?.find((item) => item.id === value)?.name;
  }, [budgets, value]);

  return (
    <Stack
      bgcolor="grey.100"
      px={0.7}
      justifyContent="space-between"
      direction="row"
      onClick={onClick}
      width={134}
      alignItems="center"
      sx={{
        cursor: "pointer",
      }}
      borderRadius={1}
    >
      <TypographyWithTooltip
        fontWeight="medium"
        color="text.secondary"
        sx={{ whiteSpace: "nowrap" }}
        variant="caption"
        title={budgetName}
      />

      {open ? (
        <ArrowDropUpIcon color="action" />
      ) : (
        <ArrowDropDownIcon color="action" />
      )}
    </Stack>
  );
};
